import { Flex, Text, useColorModeValue } from '@chakra-ui/react';
import useOrganizationStatus from '../../../hooks/useOrganisationStatus';
import { useState } from 'react';
import { useContext } from 'react';
import LiveEventDataListFilter from './LiveEventDataListFilter';
import LiveEventDataListContext from '../../../store/client/LiveEventDataListContext';
import { formatDateRangeLabel } from './scanDateBounds';
import PageHeadingWithTrialProgress from '../dashboard/PageHeadingWithTrialProgress';

function getFiltersString(filters) {
  const {
    reader,
    pass,
    scanType,
    status,
    validationType,
    groupTags,
    passTemplate,
    createdAfter,
    createdBefore,
  } = filters;

  let values = [];

  if (reader !== '') {
    values.push(reader.label);
  }
  if (pass !== '') {
    values.push(pass);
  }
  if (scanType !== '') {
    values.push(scanType.label);
  }
  if (status !== '') {
    values.push(status.label);
  }
  if (validationType !== '') {
    values.push(validationType.label);
  }
  if (groupTags?.length) {
    values.push(groupTags.map((tag) => tag.label).join(', '));
  }
  if (passTemplate?.length) {
    values.push(passTemplate.map((template) => template.label).join(', '));
  }
  const dateRangeLabel = formatDateRangeLabel(createdAfter, createdBefore);
  if (dateRangeLabel) {
    values.push(dateRangeLabel);
  }

  const count = values.length;
  let outString = '';
  values.forEach((value, index) => {
    if (index === count - 1) {
      outString = outString + value;
    } else {
      outString = outString + value + ', ';
    }
  });

  return outString;
}

const LiveEventDataHeader = () => {
  const { shouldRender } = useOrganizationStatus();
  const [loadingDashHeader, setLoadingDashHeader] = useState(true);
  const [loadingDashBody, setLoadingDashBody] = useState(true);
  const liveEventDataListCtx = useContext(LiveEventDataListContext);
  const filters = getFiltersString(liveEventDataListCtx.filterValues);
  const filterModeColor = useColorModeValue('secondaryDark08', 'white');

  return (
    <>
      <PageHeadingWithTrialProgress
        title={
          <>
            {filters === '' ? 'Scans' : `Filter results: `}
            <Text
              as="span"
              display="inline-block"
              textStyle="bodyFamilyMedium"
              fontSize="16px"
              color={filterModeColor}
              wordBreak="break-word"
            >
              {filters}
            </Text>
          </>
        }
      />
      {shouldRender && (
        <Flex
          gap={3}
          direction={{ base: 'column', sm: 'row' }}
          alignItems={{ base: 'flex-start' }}
          justifyContent="flex-end"
          w="100%"
          mb="10px"
        >
          <LiveEventDataListFilter
            loadingDashHeader={loadingDashHeader}
            loadingDashBody={loadingDashBody}
            setLoadingDashBody={setLoadingDashBody}
            setLoadingDashHeader={setLoadingDashHeader}
          />
        </Flex>
      )}
    </>
  );
};
export default LiveEventDataHeader;
